import SnacksAsideMobileComponent from './SnacksAsideMobileComponent.container';


export default SnacksAsideMobileComponent;